<template>
    <div class="flex items-center mb-lg">
        <div
            v-if="product.agreement_texts.service"
            class="flex mr-lg"
        >
            <adaptive-modal
                name="service-agrement-modal"
                title="Avtalstext tjänster"
                :hide-action-buttons="true"
            >
                <!-- eslint-disable vue/no-v-html -->
                <p v-html="product.agreement_texts.service" />
            </adaptive-modal>
            <button
                type="button"
                class="btn-link"
                @click="$modal.show('service-agrement-modal')"
            >
                Avtalstext tjänst
            </button>
        </div>
        <div
            v-if="product.agreement_texts.installation"
            class="flex"
        >
            <adaptive-modal
                name="installation-agrement-modal"
                title="Avtalstext installation"
                :hide-action-buttons="true"
            >
                <!-- eslint-disable vue/no-v-html -->
                <p v-html="product.agreement_texts.installation" />
            </adaptive-modal>
            <button
                type="button"
                class="btn-link"
                @click="$modal.show('installation-agrement-modal')"
            >
                Avtalstext installation
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            product: {
                type: Object,
                required: true,
            },
        },
    };
</script>
